<template>
  <div>
    <v-dialog max-width="700px" persistent v-model="isOpen">
      <v-card>
        <v-card-title>Maintenance</v-card-title>
        <v-form ref="form" data-vv-scope="formEditPOMaintenance">
          <v-card-text class="pt-0">
            <v-container grid-list-md class="pb-0">
              <!-- bảo dưỡng miễn phí -->
              <v-layout wrap>
                <v-flex xs12>
                  <v-checkbox
                    label="Free maintenance"
                    v-model="formData.free_maintenance"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 v-show="formData.free_maintenance">
                  <v-layout wrap>
                    <v-flex md6 xs12>
                      <v-text-field
                        label="Number of periodic maintenance"
                        required
                        name="periodic_maintenance"
                        :error-messages="
                          errors.collect(
                            'formEditPOMaintenance.periodic_maintenance'
                          )
                        "
                        v-validate="{
                          required: formData.free_maintenance,
                          regex: /^\+?[0-9]+$/s,
                          max_value: 100000,
                          min_value:
                            formData.form_free_maintenance.maintain_num,
                        }"
                        v-model="
                          formData.form_free_maintenance.periodic_maintenance
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-text-field
                        label="Maintain number"
                        required
                        disabled
                        v-model="formData.form_free_maintenance.maintain_num"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-text-field
                        label="Number of remaining periodic maintenance"
                        required
                        disabled
                        name="remaining_periodic_maintenance"
                        :error-messages="
                          errors.collect(
                            'formEditPOMaintenance.remaining_periodic_maintenance'
                          )
                        "
                        v-model="
                          formData.form_free_maintenance
                            .remaining_periodic_maintenance
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-layout>
                        <v-flex md7 xs7>
                          <v-text-field
                            label="Frequency"
                            required
                            name="free_frequency"
                            :error-messages="
                              errors.collect(
                                'formEditPOMaintenance.free_frequency'
                              )
                            "
                            v-validate="{
                              required: formData.free_maintenance,
                              regex: /^\+?[0-9]+$/s,
                              min_value: formData.free_maintenance ? 1 : 0
                            }"
                            v-model="formData.form_free_maintenance.frequency"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md5 xs5>
                          <v-autocomplete
                            :items="frequencyTimeOptions"
                            label="Day/Month"
                            small-chips
                            v-model="
                              formData.form_free_maintenance.frequency_time
                            "
                            :rules="[rules.required]"
                            v-validate="'required'"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <!-- end bảo dưỡng miễn phí -->
              <!-- Bảo dưỡng tính phí -->
              <v-layout wrap>
                <v-flex xs12>
                  <v-checkbox
                    label="Charge maintenance"
                    v-model="formData.chargeable_maintenance"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 v-show="formData.chargeable_maintenance">
                  <v-layout wrap>
                    <v-flex md6 xs12>
                      <v-text-field
                        label="Number of charged maintenance"
                        required
                        name="charge_maintenance"
                        :error-messages="
                          errors.collect(
                            'formEditPOMaintenance.charge_maintenance'
                          )
                        "
                        v-validate="{
                          required: formData.chargeable_maintenance,
                          regex: /^\+?[0-9]+$/s,
                          max_value: 100000,
                          min_value:
                            formData.form_chargeable_maintenance.maintain_num,
                        }"
                        v-model="
                          formData.form_chargeable_maintenance
                            .periodic_maintenance
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-text-field
                        label="Maintain number"
                        required
                        disabled
                        v-model="
                          formData.form_chargeable_maintenance.maintain_num
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-text-field
                        label="Number of remaining charged maintenance"
                        required
                        disabled
                        name="remaining_charge_maintenance"
                        :error-messages="
                          errors.collect(
                            'formEditPOMaintenance.remaining_charge_maintenance'
                          )
                        "
                        v-model="
                          formData.form_chargeable_maintenance
                            .remaining_periodic_maintenance
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-layout>
                        <v-flex md7 xs7>
                          <v-text-field
                            label="Frequency"
                            required
                            name="charge_frequency"
                            :error-messages="
                              errors.collect(
                                'formEditPOMaintenance.charge_frequency'
                              )
                            "
                            v-validate="{
                              required: formData.chargeable_maintenance,
                              regex: /^\+?[0-9]+$/s,
                              min_value: formData.chargeable_maintenance ? 1 : 0
                            }"
                            v-model="
                              formData.form_chargeable_maintenance.frequency
                            "
                          ></v-text-field>
                        </v-flex>
                        <v-flex md5 xs5>
                          <v-autocomplete
                            :rules="[rules.required]"
                            v-validate="'required'"
                            :items="frequencyTimeOptions"
                            label="Day/Month"
                            required
                            small-chips
                            v-model="
                              formData.form_chargeable_maintenance
                                .frequency_time
                            "
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <!-- end bảo dưỡng tính phí -->
              <!-- form hợp đôngg -->
              <v-layout wrap v-if="formData.chargeable_maintenance">
                <v-flex xs12>
                  <v-btn @click="addContract" color="primary"
                    >Add Contract</v-btn
                  >
                </v-flex>
                <v-layout
                  wrap
                  v-for="(row, index) in formData.form_chargeable_maintenance
                    .form_contact"
                  :key="index"
                >
                  <v-flex xs12>
                    <v-checkbox
                      label="Show info on cibes backoffice"
                      v-model="row.check_point"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      label="Maintenance contract number"
                      required
                      v-model="row.maintenance_contract_number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      label="Maintenance package"
                      required
                      v-model="row.maintenance_package"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="row.contract_signing_date"
                      full-width
                      lazy
                      min-width="290px"
                      offset-y
                      :ref="'dialog' + index"
                      transition="scale-transition"
                      v-model="contractDate[index]"
                    >
                      <v-text-field
                        label="Contract signing date"
                        prepend-icon="event"
                        readonly
                        slot="activator"
                        v-model="row.contract_signing_date"
                      ></v-text-field>
                      <v-date-picker
                        no-title
                        scrollable
                        v-model="row.contract_signing_date"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="contractDate[index] = false"
                          color="primary"
                          flat
                          >Cancel</v-btn
                        >
                        <v-btn
                          @click="
                            $refs['dialog' + index][0].save(
                              row.contract_signing_date
                            )
                          "
                          color="primary"
                          flat
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="row.effective_time"
                      full-width
                      lazy
                      min-width="290px"
                      offset-y
                      :ref="'effect' + index"
                      transition="scale-transition"
                      v-model="effectiveTime[index]"
                    >
                      <v-text-field
                        label="Expiration time"
                        prepend-icon="event"
                        readonly
                        slot="activator"
                        v-model="row.effective_time"
                      ></v-text-field>
                      <v-date-picker
                        no-title
                        scrollable
                        v-model="row.effective_time"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="effectiveTime[index] = false"
                          color="primary"
                          flat
                          >Cancel</v-btn
                        >
                        <v-btn
                          @click="
                            $refs['effect' + index][0].save(row.effective_time)
                          "
                          color="primary"
                          flat
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="formData.next_maintain_date_hard"
                    full-width
                    lazy
                    min-width="290px"
                    offset-y
                    ref="next_maintain_date_hard"
                    transition="scale-transition"
                    v-model="isDatePickerNextMaintainOpen"
                  >
                    <v-text-field
                      label="Next Maintenance date"
                      prepend-icon="event"
                      readonly
                      clearable
                      slot="activator"
                      v-model="formData.next_maintain_date_hard"
                    ></v-text-field>
                    <v-date-picker
                      no-title
                      scrollable
                      :allowed-dates="allowedDates"
                      v-model="formData.next_maintain_date_hard"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="isDatePickerNextMaintainOpen = false"
                        color="primary"
                        flat
                        >Cancel</v-btn
                      >
                      <v-btn
                        @click="
                          $refs.next_maintain_date_hard.save(
                            formData.next_maintain_date_hard
                          )
                        "
                        color="primary"
                        flat
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <!-- end form hợp đồng -->
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex md4 xs12>Last Maintenance Date:</v-flex>
                    <v-flex md8 xs12 class="body-2">{{
                      formData.latest_maintain_date
                        | morph-date("YYYY/MM/DD")
                    }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex md4 xs12>Next Maintenance Date:</v-flex>
                    <v-flex md8 xs12 class="body-2">{{
                      formData.next_maintain_date | morph-date("YYYY/MM/DD")
                    }}</v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12>
                  <v-textarea
                    label="Internal note"
                    v-model="formData.maintenance_note"
                  ></v-textarea>
                </v-flex>

                <v-flex xs12>
                  <v-autocomplete
                    label="Select user assign"
                    multiple
                    small-chips
                    hide-no-data
                    :loading="loadingSelectUser"
                    :items="userList"
                    :search-input.sync="userQuery"
                    v-model="formData.assign_users"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center>
                <v-flex md9 xs12>
                  <v-btn block color="primary" @click="saveAndSendZalo">
                    Send Zalo OA to customer
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogConfirm = true">Cancel</v-btn>
            <v-btn @click="save" color="primary">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog max-width="450px" persistent v-model="dialogStatus">
      <v-card>
        <v-card-title>
          <span class="headline">Alert</span>
        </v-card-title>
        <v-card-text>{{ errorMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogStatus = false" style="width: 85px">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="450px" persistent v-model="dialogConfirm">
      <v-card>
        <v-card-title>
          <span class="headline">Alert</span>
        </v-card-title>
        <v-card-text>Are you sure to cancel the changes?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
          <v-btn @click="close" color="primary" style="width: 85px">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { get } from "lodash";
import PurchaseOrderService from "../services/purchase.order.service.js";
import { startOfDay } from "date-fns";

const validatorDictionary = {
  custom: {
    periodic_maintenance: {
      required: () => "It is required field",
      max_value: () => "Maximum numbers is 100000",
      regex: () => "This field may only contain numeric characters.",
      min_value: () => "This field must be greater than maintain number.",
    },
    charge_maintenance: {
      required: () => "It is required field",
      max_value: () => "Maximum numbers is 100000",
      regex: () => "This field may only contain numeric characters.",
      min_value: () => "This field must be greater than maintain number.",
    },
    remaining_periodic_maintenance: {
      required: () => "It is required field",
      max_value: () => "Maximum numbers is 100000",
      regex: () => "This field may only contain numeric characters.",
    },
    remaining_charge_maintenance: {
      required: () => "It is required field",
      max_value: () => "Maximum numbers is 100000",
      regex: () => "This field may only contain numeric characters.",
    },
    free_frequency: {
      required: () => "It is required field",
      regex: () => "This field may only contain numeric characters.",
      min_value: () => "This field must be greater than or equal to 1.",
    },
    charge_frequency: {
      required: () => "It is required field",
      regex: () => "This field may only contain numeric characters.",
      min_value: () => "This field must be greater than or equal to 1.",
    },
  },
};

export default {
  inject: ["$validator"],
  model: {
    prop: "open",
    event: "toggle",
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    poId: {
      type: String,
      required: true,
    },
    loadingSelectUser: {
      type: Boolean,
      default: false,
    },
    refetchData: {
      type: Function,
      default: () => {},
    },
    userList: {
      validator: function (list) {
        return (
          Array.isArray(list) &&
          list.every(
            (item) =>
              typeof item.text === "string" && typeof item.value === "string"
          )
        );
      },
    },
  },
  data() {
    return {
      purchaseOrderService: new PurchaseOrderService(),
      isOpen: false,
      isDatePickerNextMaintainOpen: false,
      dialogStatus: false,
      dialogConfirm: false,
      errorMessage: "",
      userQuery: "",
      contractDate: [],
      effectiveTime: [],
      formData: {
        free_maintenance: false,
        form_free_maintenance: {
          maintain_num: 0,
          periodic_maintenance: 0,
          remaining_periodic_maintenance: 0,
          frequency: 0,
          frequency_time: "",
        },
        next_maintain_date_hard: "",
        chargeable_maintenance: false,
        form_chargeable_maintenance: {
          maintain_num: 0,
          periodic_maintenance: 0,
          remaining_periodic_maintenance: 0,
          form_contact: [],
          frequency: 0,
          frequency_time: "",
        },
        latest_maintain_date: "",
        next_maintain_date: "",
        maintenance_note: "",
        assign_users: [],
      },
      rules: {
        required: (v) => (v && v.trim().length > 0) || "It is required field",
      },
      frequencyTimeOptions: [
        {
          text: "Day",
          value: "days",
        },
        {
          text: "Month",
          value: "month",
        },
      ],
    };
  },
  methods: {
    allowedDates(date) {
      // Disable past dates
      const today = new Date();
      return startOfDay(date) >= startOfDay(today);
    },
    fetchData() {
      this.purchaseOrderService.getMaintenanceDetail(this.poId).then((res) => {
        this.formData = {
          ...res.data,
          assign_users: res.data.assign_users.map((u) => u.id),
          // next_maintain_date_hard: res.data.next_maintain_date
          //     ? this.$morphDate(res.data.next_maintain_date, "YYYY-MM-DD")
          //     : "",
          form_chargeable_maintenance: {
            ...res.data.form_chargeable_maintenance,
            form_contact: res.data.form_chargeable_maintenance.form_contact.map(
              (c) => ({
                ...c,
                contract_signing_date: c.contract_signing_date
                  ? this.$morphDate(c.contract_signing_date, "YYYY-MM-DD")
                  : null,
                effective_time: c.effective_time
                  ? this.$morphDate(c.effective_time, "YYYY-MM-DD")
                  : null,
              })
            ),
          },
        };
        this.$nextTick(() => {
          this.isOpen = true;
        });
      });
    },
    addContract() {
      if (
        this.formData.form_chargeable_maintenance &&
        Array.isArray(this.formData.form_chargeable_maintenance.form_contact)
      ) {
        this.formData.form_chargeable_maintenance.form_contact.push({
          check_point: false,
          contract_signing_date: null,
          effective_time: null,
          maintenance_contract_number: 0,
          maintenance_package: "",
        });
      }
    },
    validateThen(callback) {
      this.$validator.validate("formEditPOMaintenance.*").then((result) => {
        const extraValidated = this.$refs.form.validate();
        if (result && extraValidated) {
          this.formData.form_free_maintenance.periodic_maintenance =
            +this.formData.form_free_maintenance.periodic_maintenance;
          this.formData.form_free_maintenance.remaining_periodic_maintenance =
            +this.formData.form_free_maintenance.remaining_periodic_maintenance;
          this.formData.form_free_maintenance.frequency =
            +this.formData.form_free_maintenance.frequency;
          this.formData.form_chargeable_maintenance.periodic_maintenance =
            +this.formData.form_chargeable_maintenance.periodic_maintenance;
          this.formData.form_chargeable_maintenance.remaining_periodic_maintenance =
            +this.formData.form_chargeable_maintenance
              .remaining_periodic_maintenance;
          this.formData.form_chargeable_maintenance.frequency =
            +this.formData.form_chargeable_maintenance.frequency;
          const data = { ...this.formData };
          callback(data);
        }
      });
    },
    save() {
      this.validateThen((data) => {
        this.purchaseOrderService
          .editMaintenanceDetail(this.poId, data)
          .then((res) => {
            if (res.data && res.data.statusCode === 200) {
              this.refetchData();
              this.close();
            } else {
              this.dialogStatus = true;
              this.errorMessage = res.data.message;
            }
          });
      });
    },
    saveAndSendZalo() {
      this.validateThen((data) => {
        this.purchaseOrderService
          .editMaintenanceDetailAndSendZalo(this.poId, data)
          .then((res) => {
            if (res.data.data.data) {
              this.formData.next_maintain_date =
                res.data.data.data.next_maintain_date;
              this.formData.next_maintain_date_hard = "";
            }
            if (!(res.data && res.data.statusCode === 200)) {
              this.dialogStatus = true;
              this.errorMessage = res.data.message;
            }
          });
      });
    },
    close() {
      this.$emit("toggle", false);
      this.refetchData();
    },
  },
  watch: {
    open(value) {
      if (value) {
        this.fetchData();
      } else {
        this.$refs.form.reset();
        this.$validator.reset();
        this.isOpen = false;
        this.dialogConfirm = false;
      }
    },
    userQuery: {
      handler(query) {
        this.$emit("user-query", query);
      },
      immediate: false,
    },
  },
  created() {
    this.unwatchDeepWatchers = [
      this.$watch(
        function () {
          return get(
            this.formData,
            "form_free_maintenance.periodic_maintenance",
            0
          );
        },
        function (newValue) {
          if (newValue > 0) {
            this.formData.form_free_maintenance.remaining_periodic_maintenance =
              +newValue - this.formData.form_free_maintenance.maintain_num;
          } else {
            this.formData.form_free_maintenance.remaining_periodic_maintenance =
              0;
          }
        }
      ),
      this.$watch(
        function () {
          return get(
            this.formData,
            "form_chargeable_maintenance.periodic_maintenance",
            0
          );
        },
        function (newValue) {
          if (newValue > 0) {
            this.formData.form_chargeable_maintenance.remaining_periodic_maintenance =
              +newValue -
              this.formData.form_chargeable_maintenance.maintain_num;
          } else {
            this.formData.form_chargeable_maintenance.remaining_periodic_maintenance =
            0;
          }
        }
      ),
    ];
  },
  mounted() {
    this.$validator.localize("en", validatorDictionary);
  },
  beforeDestroy() {
    this.unwatchDeepWatchers.forEach((unwatch) => {
      unwatch();
    });
  },
};
</script>
